import React, { useRef, useState } from 'react';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';
import plusIcon from '../images/plus-icon.svg';
import minusIcon from '../images/minus-icon.svg';

import { Container, Panel } from './styles';

const MobileFeatures = ({ items, callToAction }) => {
  let containerRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePanelClick = index => {
    index === activeIndex ? setActiveIndex(null) : setActiveIndex(index);

    const position = containerRef.current.getBoundingClientRect().top;
    const scrollPosition =
      index === 0 ? position - 100 : index === 1 ? position - 10 : position + 75;
    window.scrollBy({
      top: scrollPosition,
      behavior: 'smooth',
    });
  };

  return (
    <Container ref={containerRef}>
      <div className="custom-accordion-container">
        {items?.map((item, index) => {
          return (
            <FeaturePanel
              active={index === activeIndex}
              callToAction={callToAction}
              copy={item?.description}
              handleClick={handlePanelClick}
              header={item?.title}
              icon={item?.icon?.image?.file?.url}
              image={item?.featuredImage?.image?.file?.url}
              index={index}
            />
          );
        })}
      </div>
    </Container>
  );
};

const FeaturePanel = ({ active, callToAction, copy, handleClick, header, icon, image, index }) => {
  return (
    <Panel
      className={`custom-accordion-panel ${active ? 'active' : 'inactive'}`}
      onClick={() => handleClick(index)}
    >
      <div className="custom-accordion-panel-header">
        <h3>{header}</h3>
        {active ? <img src={minusIcon} /> : <img src={plusIcon} />}
      </div>
      <div className={`custom-accordion-panel-content ${active ? 'active' : 'inactive'}`}>
        <img src={image} />
        <ContentfulRichText
          richText={{
            content: copy,
            listIcon: icon,
          }}
        />
        {callToAction && <ContentfulCallToAction {...callToAction} />}
      </div>
    </Panel>
  );
};

export default MobileFeatures;
